module.exports = __webpack_public_path__ + "img/lottery_bg3.5c31ca6d.png";